import React from 'react';
import {ALIGN, COLOR, Portal, Panel as AuroraPanel} from '@lookiero/aurora';
import {SubNavigation} from '@components/molecules/SubNavigation';
import {ScrollView} from '@components/layouts/layout/components/scrollView/ScrollView';

type PanelProps = {
  id: string;
  visible: boolean;
  title: string;
  onBack: () => void;
  children: React.ReactNode;
};

export const Panel: React.FC<PanelProps> = ({id, visible, title, onBack, children}) => {
  return (
    <Portal id={id}>
      <AuroraPanel align={ALIGN.RIGHT} color={COLOR.BG_BASE} isVisible={visible} onClose={onBack}>
        <ScrollView stickyHeaderIndices={[0]} keyboardShouldPersistTaps="handled">
          <SubNavigation onBack={onBack} title={title} />
          {children}
        </ScrollView>
      </AuroraPanel>
    </Portal>
  );
};
